module.exports = __webpack_public_path__ + "img/3.742c87ec.png";